<template>
  <div class="content_bg">
    <Nav curNavId="2" pathUrl='plant' @circle="clickNav"/>
    <div class="content_bottom">
      <div class="c_b_left">
        <div class="leftBox1 flexColumn">
          <div class="title">项目进度</div>
          <div class="leftInfo1 flexColumn">
            <div class="leftInfo1_A flexColumn">
              <div class="subTitle">
                <div class="titleLeft">一期项目<span>15000亩</span></div>
                <div class="titleRight">占比 <span>30%</span></div>
              </div>
              <div class="echarts"><lefthtBar /></div>
            </div>
            <div class="line"></div>
            <div class="leftInfo1_A flexColumn">
              <div class="subTitle">
                <div class="titleLeft">二期项目<span>35000亩</span></div>
                <div class="titleRight">占比 <span>70%</span></div>
              </div>
              <div class="echarts"><lefthtBar1 /></div>
            </div>

          </div>
        </div>
        <div class="leftBox2 flexColumn">
          <div class="title">投资占比</div>
          <div class="echarts"><LefthtPie /></div>
        </div>
        <div class="leftBox3 flexColumn">
          <div class="title">工作纪实</div>
          <div class="left3Video"><vue3VideoPlay :control="false"  :controlBtns="false" color="#ff0000" width="100%" height="100%" title="冰河世纪" :src="options1.src" :type="options1.type" :autoPlay="false"  @play="onPlay" /></div>
        </div>



      </div>
      <div class="c_b_middle">
          <div class="centerVideo"><div class="videoBox" v-if="AccessToken!=''"><iframe :src="options.src + AccessToken  " width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe></div></div>
          <div class="centerBottom">
            <div class="center_b_l">
              <div class="centerBottomItem" v-for="(item,index) in centerList_l" :key="index">
                <img src="../assets/img/gbzntjsyzt/img1/z.png"/>
                <span class="left">{{item.value}}{{item.unit}}</span>
                <span class="right">{{item.name}}</span>
              </div>
            </div>
            <img src="../assets/img/gbzntjsyzt/img1/gg.png" style="width: 244px;height: 104px;margin: 0 10px"/>
            <div class="center_b_r">
              <div class="centerBottomItem" v-for="(item,index) in centerList_r" :key="index">

                <span class="right">{{item.name}}</span>
                <span class="left">{{item.value}}{{item.unit}}</span>
                <img src="../assets/img/gbzntjsyzt/img1/z.png"/>
              </div>
            </div>
          </div>
      </div>
      <div class="c_b_right">
          <div class="rightBox1 flexColumn">
            <div class="title">效益分析</div>
            <div class="echarts"><leftBar /></div>
          </div>
        <div class="rightBox2 flexColumn">
          <div class="title">经济效益</div>
          <div class="rightInfo2">
            <div class="rightItem2" v-for="(item,index) in rightData2" :key="index">
              <img :src="item.icon"/>
              <div class="rightItem2_r"><span>{{item.name}}</span><span>{{item.value}}{{item.unit}}</span></div>
            </div>
          </div>
        </div>
        <div class="rightBox3 flexColumn">
          <div class="title">社会效益</div>
          <div class="rightInfo3">
            <div class="rightInfo3Item0 flexColumn" v-for="(item,index) in rightData3" :key="index">
              <div class="rightInfo3_top">
                <div class="rightInfo3_top_item" v-for="(item1,index1) in item.arr" :key="index1">
                  <img src="../assets/img/gbzntjsyzt/img1/nh.png" />
                  <div class="right"><span class="value">{{item1.value}}{{item1.unit}}</span><span class="name">{{item1.name}}</span></div>
                </div>
              </div>
              <div class="rightInfo3_bottom">{{item.txt}}</div>
              <div class="line" v-if="index==0" style="margin: 20px 0"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <footer1 />
  <CircleNav :isShow="circleShow"  @closeCircle1="circleHiddlen"  />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from 'vue-router'
import {
  reactive,
  toRefs,
  ref,
  onMounted,
  computed,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
import Nav from "../components/nav.vue";
import txtScroll from "../components/txtScroll.vue";
import rightPie from "../components/gbzntjs/rightPie.vue";
import leftBar from "../components/gbzntjs/leftBar.vue";
import LefthtPie from "../components/gbzntjs/lefthtPie.vue"
import lefthtBar from "../components/gbzntjs/lefthtBar.vue"
import lefthtBar1 from "../components/gbzntjs/lefthtBar1.vue"
import rigsbq from "../components/gbzntjs/rigsbq.vue";
import footer1 from "../components/footer.vue";
import CircleNav from "@/components/circleNav.vue";
// import Left1Line from "../components/cangchu/left1Line";

export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      currentTime: "",
      options: {
        src: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型
      },
      options1: {
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nongye/liangtianqianqin.mp4", //视频源
        type: "video/mp4", //视频类型
      },
      centerList_l:[
        {name:"固定式喷灌",value:900,unit:"亩"},
        {name:"平移式喷灌",value:750,unit:"亩"},
        {name:"微灌式喷灌",value:9850,unit:"亩"},
      ],
      centerList_r:[
        {name:"半固定式喷灌",value:9000,unit:"亩"},
        {name:"绞盘式喷灌",value:29500,unit:"亩"},
        {name:"总计",value:50000,unit:"亩"}
      ],
      rightData2:[
        {name:"新增粮食",value:250,unit:"万公斤",icon:require("../assets/img/gbzntjsyzt/img1/ls.png")},
        {name:"新增油料",value:150,unit:"万公斤",icon:require("../assets/img/gbzntjsyzt/img1/yl.png")},
        {name:"增加效益",value:1521,unit:"万元",icon:require("../assets/img/gbzntjsyzt/img1/zj.png")}
      ],
      rightData3:[
        {
          arr:[{name:"直接受益农户",value:8333,unit:"户"},
            {name:"直接受益人",value:24997,unit:"人"},],
          txt:"直接受益农户年均纯收入增加850元，"
        },
        {
          arr:[{name:"间接灌溉受益",value:1.6,unit:"万户"},
            {name:"灌溉改良",value:10,unit:"万亩"},],
          txt:"灌溉改良农户间接收益增加600元，"
        }
      ],
      config: {
        colors: ["#03947B", "#03947B"],
        value: 100,
        borderWidth: 1,
        borderRadius: 3,
        borderGap: 1,
      },
      config1: {
        colors: ["#03947B", "#03947B"],
        value: 30,
        borderWidth: 1,
        borderRadius: 3,
        borderGap: 1,
      },
      textList: [
        { title: "高标准农田是指在一定时期内，按照国家相关标准和规划要求，在适宜农业生产区域建设的综合生产能力和生态环境良好的永久基本农田。它具有以下几个显著特征：", },
        { title: "高产稳产：通过土地平整、土壤改良、灌溉排水设施完善等措施，提高农田产出能力，确保粮食和其他农产品稳定高产。",
        },
        { title: "集中连片：农田布局合理，田块规整，便于规模化、机械化作业和统一管理，降低生产成本，提高劳动效率。",
        },
        { title: "设施配套：配备完善的水利、电力、道路等基础设施，包括但不限于节水灌溉系统、排涝防洪设施、田间道路网等，以满足现代农业生产和经营需要。", },
        {
          title:
            "生态友好：注重农田生态保护与修复，实施耕地质量保护提升工程，强化农业面源污染治理，实现农田可持续利用。",
        },
        {
          title:
            "信息化程度高：推广现代信息技术应用，如遥感监测、物联网技术、精准农业等，提升农田管理智能化水平。",
        },
        {
          title:
            "信息化程度高：推广现代信息技术应用，如遥感监测、物联网技术、精准农业等，提升农田管理智能化水平。",
        },
      ],
      imgShow:false,
      curimgIndex:1,
      AccessToken:"",
      circleShow:false
    });
    // 返回上一页
    function clickReturn(){
      router.go(-1);
    }
    function chunkString(str, chunkSize) {
      if (str.length <= chunkSize) {
        return [str];
      }
      return [str.slice(0, chunkSize), ...chunkString(str.slice(chunkSize), chunkSize)];
    }
    // 看大图
    function bigImg(index){
      state.curimgIndex = index
      state.imgShow=true
    }
     function clickImg(){
      state.imgShow=false
    }
    function clickNav(isShow){
      console.log(isShow)
      state.circleShow = isShow.show
    }
    function circleHiddlen(data1){
      // console.log('circle')
      state.circleShow = data1.show
    }
    onMounted(() => {
      state.AccessToken = localStorage.getItem("AccessToken");
      const text = "项目区直接受益农户8333户、24997人，直接受益农户年均纯收入增加1830元，辐射带动周边乡镇应用高效节水灌溉面积10万亩以上，间接受益农户1.6万户以上，辐射区粮油效益增加2000万元以上，受益农户年均纯收入增加1200元以上。项目区直接受益农户8333户、24997人，直接受益农户年均纯收入增加1830元，辐射带动周边乡镇应用高效节水灌溉面积10万亩以上，间接受益农户1.6万户以上，辐射区粮油效益增加2000万元以上，受益农户年均纯收入增加1200元以上。";
      state.textList = chunkString(text, 28);
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),
      clickReturn,
      chunkString,
      bigImg,
      clickNav,
      circleHiddlen
    };
  },
  components: {
    CircleNav,
    Nav,
    txtScroll,
    rightPie,
    rigsbq,
    leftBar,
    footer1,
    LefthtPie,
    lefthtBar,
    lefthtBar1
  },
};
</script>
<style lang="less" scoped>
::v-deep .dv-percent-pond text{
  font-size: 18px;
  font-weight: normal;
}
.content_bg {
  width: 100%;
  height: 100%;
  background: url("../assets/img/gbzntjsyzt/img/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;

  .flexColumn{
    display: flex;
    flex-direction: column;
  }
  .echarts{
    width: 100%;
    flex: 1;
  }
  .title{
    width:100%;
    height: 40px;
    font-weight: bold;
    background: url("../assets/img/huanjing/xbt.png") no-repeat left bottom;
    color: #fff;
    font-size: 20px;
    line-height: 20px;
    text-align: left;
    padding-left: 30px;
  }
  .line{
    width: 100%;
    height:6px ;
    background: linear-gradient(to right,rgba(10,35,52,0),rgba(24,59,63,1),rgba(10,35,52,0));
    margin: -16px 0 20px;
  }
  .content_bottom {
    width: 100%;
    height: calc(100% - 99px);
    display: flex;
    justify-content: space-between;
    //border: 1px solid #f00;
    margin-top: -19px;
    .c_b_left {
      width: 432px;
      height: 100%;
      background: url("../assets/img/huanjing/ck.png") no-repeat;
      background-size: 100% 100%;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      margin-left: 35px;
      .leftBox1,.leftBox2{
        flex: 1;
      }
    .leftBox1{
      .leftInfo1{
        flex: 1;
        padding: 20px 25px;
        justify-content: space-between;
        .leftInfo1_A{
          width: 100%;
          flex: 1;
          .subTitle{
            display: flex;
            color: #fff;
            font-size: 15px;
            justify-content: space-between;
           height: 40px;
           line-height: 40px;
            .titleLeft{
              span{
                font-size: 28px;
                color: #3AF7B5;
                margin-left: 20px;
              }
            }
            .titleRight{
              span{
                font-size: 23px;
                color: #FF6C1D;
                margin-left: 20px;
              }
            }
          }
        }
      }
    }
      .leftBox3{
        height:307px ;
        .left3Video{
          width: 372px;
          height: 207px;
          background: url("../assets/img/gbzntjsyzt/img1/spk.png") no-repeat;
          margin: 30px auto;
          padding: 10px;
        }
      }

    }
    .c_b_middle {
      height: 100%;
      width: 911px;
      margin: 40px 0 0;
      display: flex;
      flex-direction: column;
      .centerVideo{
        width: 911px;
        height: 615px;
        background: url("../assets/img/gbzntjsyzt/img1/zbj.png") no-repeat;
        padding: 24px 30px 20px 20px;
        .videoBox{
          width: 100%;
          height: 100%;
        }
      }
      .centerBottom{
        width: 100%;
        flex: 1;
        background: url("../assets/img/gbzntjsyzt/img1/jb.png") no-repeat top center;
        margin-top: 20px;
        display: flex;
        align-items: center;
        padding: 30px 30px;
        .center_b_l,.center_b_r{
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .centerBottomItem{
          width: 100%;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 15px 0;
          img{
            width: 28px;
            height: 11px;
          }
          span{
            display: block;
          }
          .left{
            font-size: 30px;
            color: #fff;
            margin: 0 16px;
          }
          .right{
            color: #fff;
            font-size: 18px;
            letter-spacing: 2px;
            text-shadow:
              0 0 5px rgba(21, 241, 187, 0.5), /* 第一层内发光 */
              0 0 10px rgba(21, 241, 187, 0.8), /* 第二层内发光 */
              0 0 15px rgba(21, 241, 187, 1);   /* 第三层内发光 */
          }

        }
      }

    }
    .c_b_right {
      width: 432px;
      height: 100%;
      background: url("../assets/img/huanjing/ck.png") no-repeat;
      background-size: 100% 100%;
      z-index: 1000;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      margin-right: 35px;
      .rightBox1{
        flex: 1;
      }
      .rightBox2{
        height: 160px;
        .rightInfo2{
          width: 100%;
          flex: 1;
          display: flex;
          justify-content: space-between;
          padding: 0 20px;
          .rightItem2{
            display: flex;
            align-items: center;
            img{
              width: 49px;
              height: 49px;
              margin-right: 10px;
            }
            .rightItem2_r{
              font-size: 14px;
              color: #fff;
            }
            span{
              text-align: left;
              display: block;
            }
          }
          .rightItem2:nth-child(1){
            span:last-child{
              color:#0BEABB ;
            }
          }
          .rightItem2:nth-child(2){
            span:last-child{
              color:#19E2E3;
            }
          }
          .rightItem2:nth-child(3){
            span:last-child{
              color:#0AD5AA;
            }
          }
        }
      }
      .rightBox3{
        //height: 300px;
        flex: 1;
        .rightInfo3{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          padding: 30px 30px;
          .rightInfo3Item0{
            width: 100%;
            //flex: 1;
            justify-content: space-between;
            .rightInfo3_top{
              width: 100%;
              flex: 1;
              display: flex;
              .rightInfo3_top_item{
                width: 50%;
                display: flex;
                align-items: center;
                img{
                  width: 46px;
                  height: 45px;
                  margin-right: 10px;
                }
                .right{
                  span{
                    display: block;
                    text-align: left;
                    font-size: 18px;
                    color: #fff;
                  }
                  span:first-child{
                    color: #11C55E;
                    padding-bottom: 5px;
                  }
                }
              }
            }
            .rightInfo3_bottom{
              width: 100%;
              height: 30px;
              background: url("../assets/img/gbzntjsyzt/img1/zj(1).png") no-repeat 0 bottom;
              font-size: 18px;
              color: #fff;
              line-height: 26px;
              text-align: left;
              padding-left: 20px;
              margin: 20px 0;
            }
          }
        }
      }
    }
  }
  .db_bg {
    width: 100%;

    height: 4%;
    background: url("../assets/img/gbzntjsyzt/img/db.png") no-repeat top center;
    background-size: 100% 100%;
  }
}
#n_sxt .d-player-wrap,#m_t_sp .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
@keyframes bianda {
  0% {
    opacity: 0.3;
    // transform: scale(1);
  }
  50% {
    opacity: 1;
    // transform: scale(0.5);
  }
  100% {
    opacity: 0.6;
    // transform: scale(1);
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes daxiao {
  0%{                     
       transform: scale(0.96);
  } 
  50%{
    transform: scale(1);
  }
   100%{
    transform: scale(0.96);
  }
}

@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
